export const EDIT_COURSE = "EDIT_COURSE"
export const EDIT_COURSE_SUCCESS = "EDIT_COURSE_SUCCESS"
export const EDIT_COURSE_CLEAN = "EDIT_COURSE_CLEAN"
export const EDIT_COURSE_ERROR = "EDIT_COURSE_ERROR"
export const EDIT_COURSE_STATUS = "EDIT_COURSE_STATUS"
export const EDIT_COURSE_STATUS_SUCCESS = "EDIT_COURSE_STATUS_SUCCESS"
export const EDIT_COURSE_STATUS_CLEAN = "EDIT_COURSE_STATUS_CLEAN"
export const EDIT_COURSE_STATUS_ERROR = "EDIT_COURSE_STATUS_ERROR"
